import React, {useState} from "react";

import {Formik, Field, Form} from 'formik';
import * as Yup from 'yup';
import {i18n} from "translate/i18n";
import {toast} from "react-toastify";
import {useQuery} from "react-query";
import Editor from "components/Editor";
import {useNavigate, useParams} from "react-router";

import {editContent, getContentId, setContent} from "services/Content.service";
import {useUser} from "store/providers/app";
import Loading from "../../../components/Loading";

const INITIAL_FORM_VALUES = {
    group: '',
    content_pt: '',
    content_en: '',
    varid: ''
}

const FormContent = () => {

    const {id} = useParams()
    const navigate = useNavigate()
    const {username} = useUser();

    const [formValues, setFormValues] = useState(INITIAL_FORM_VALUES)

    const {isFetching} = useQuery(['content', id],
        () => {
            return getContentId(id)
        }, {
            onSuccess: (res) => {

               if(res) {
                    setFormValues({
                        group: res.data.group,
                        content_pt: res.data.content_pt,
                        content_en: res.data.content_en,
                        varid: res.data.varid
                    })
               }
            },
            onError: () => {
                toast.error(i18n.t('error.badRequest'))
            },
            retry: false,
            refetchOnWindowFocus: false,
            keepPreviousData: true
        }
    )

    if(isFetching) return <Loading />

    return (
        <Formik
            initialValues={formValues}
            enableReinitialize
            onSubmit={async (values) => {

                const data = {...values, username: username}

                if(id) {
                    editContent(id, data)
                        .then(() => {
                            navigate('/redirect/content/edit/'+id)
                            toast.success(i18n.t('success.editContent'))
                        }).catch(() => toast.warning(i18n.t('error.badRequest')))

                } else {
                    setContent(data)
                        .then(() => {
                            navigate('/redirect/content/add/new')
                            toast.success(i18n.t('success.createContent'))
                        }).catch(() => toast.warning(i18n.t('error.badRequest')))
                }

            }}
        >
             {({ errors, touched, setFieldValue, values }) => (
                <Form>
                    <div className="card border-0 shadow-sm">
                        <div className="card-body">

                            <div className="form-group">
                                <label className="form-label">{i18n.t('label.varid')}</label>
                                <Field className="form-control" name="varid" disabled />
                            </div>

                            <div className="form-group">
                                <label className="form-label">{i18n.t('label.group')}</label>
                                <Field className="form-control" name="group" />
                            </div>
                            <div className="form-group">
                                <label className="form-label">PT</label>
                                <Editor
                                    handleChange={setFieldValue}
                                    data={values.content_pt}
                                    name="content_pt"
                                />
                            </div>
                            <div className="form-group">
                                <label className="form-label">EN</label>
                                <Editor
                                    handleChange={setFieldValue}
                                    data={values.content_en}
                                    name="content_en"
                                />
                            </div>
                        </div>
                        <div className="card-footer bg-white py-3">
                            <button
                                className="btn btn-success py-2 px-5 float-end"
                                type="submit"
                            > {i18n.t('buttons.save')}
                            </button>
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    )
}

export default FormContent